import { DecimalPipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { formatNumberWithDotSeparator } from '@valg-shared/utils/string-utils';

@Component({
  selector: 'valg-dk-bar-chart',
  templateUrl: './bar-chart.component.html'
})
export class BarChartComponent implements OnInit, OnChanges{
  @Input() percentage = 0;
  @Input() number?: number;
  @Input() showNumber = true;
  @Input() isPercentage = true;
  protected value = "0%";
  text = "";

  constructor(private readonly numberPipe: DecimalPipe){ }

  ngOnInit(): void {
    this.formatValue();
  }

  ngOnChanges(): void {
      this.formatValue();
  }

  formatValue(){
    this.value = this.percentage != null ? this.percentage+'%' : '';
    if(this.number !== undefined){
      this.text = formatNumberWithDotSeparator(this.number);
    } else{
      this.text = this.numberPipe.transform(this.percentage, '1.1-1')?.toString()+'%' ?? this.value;
    }
  }

  get shouldApplyLineSeparator(): boolean {
    return this.percentage < 100;
  }
}
